import { AfterViewInit, Component, OnInit, ViewChild, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';
import { filter, take, withLatestFrom } from 'rxjs/operators';

import { AppState } from '../../model/reducer';
import { ClearUserError, Login } from '../../user';
import { NavigationService } from '../../navbar/navigation.service';

@Component({
    selector: 'adm4-login',
    template: `
    <div class='login-container'>
      <img class='application-logo' [src]="'assets/Logo-Nevis-RGB-positive.svg'" alt=''/>
      <h1>Log in to nevisAdmin 4</h1>
    
      <form name='form'
        (ngSubmit)='f.form.valid && login()'
        #f='ngForm'
        novalidate>
        <div class='adm4-form-group' [ngClass]="{ 'has-error': f.submitted && !username.valid }">
          <div class="input-group position-relative">
            <input type='text'
              class='form-control login-control-border-radius'
              name='username'
              placeholder='User name'
              [(ngModel)]='model.username'
              (ngModelChange)='resetError()'
              #username='ngModel'
              #userNameInput
              required
              autofocus/>
            <!-- Edge didn't display svg in background when it's cached, therefore this workaround is applied to avoid that problem, because no idea why it happens, rly -->
            <img src='assets/login-profil-off.svg' alt='' class='input-group-text input-group-icon username-addon-off'/>
            <img src='assets/login-profil-on.svg' alt='' class='input-group-text input-group-icon username-addon'/>
            <img src='assets/loginUsernameInvalid.svg' alt='' class='input-group-text input-group-icon username-addon-error'/>
          </div>
          <div class='validation-message-container'>
            @if (f.submitted && !username.valid) {
              <div class='invalid-feedback'>
                <adm4-validation-indicator [isDisplayed]='true' [isError]='true' [diameter]='8'></adm4-validation-indicator>
                Username is required
              </div>
            }
          </div>
        </div>
        <div class='adm4-form-group' [ngClass]="{ 'has-error': f.submitted && !password.valid }">
          <div class="input-group position-relative">
            <input type='password'
              class='form-control login-control-border-radius'
              name='password'
              placeholder='Password'
              [(ngModel)]='model.password'
              (ngModelChange)='resetError()'
              #password='ngModel'
              required/>
            <span class='input-group-text input-group-icon password-addon'></span>
          </div>
          <div class='validation-message-container'>
            @if (f.submitted && !password.valid) {
              <div class='invalid-feedback'>
                <adm4-validation-indicator [isDisplayed]='true' [isError]='true' [diameter]='8'></adm4-validation-indicator>
                Password is required
              </div>
            }
            @if (error$ | async) {
              <div class='error-message'>
                <adm4-validation-indicator [isDisplayed]='true' [isError]='true' [diameter]='8'></adm4-validation-indicator>
                {{(error$ | async)}}
              </div>
            }
          </div>
        </div>
        <div class='adm4-form-group'>
          <button class="login-control-border-radius">Login</button>
        </div>
      </form>
    </div>
    `,
    styleUrls: ['login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit, AfterViewInit {
  private readonly store$ = inject<Store<AppState>>(Store);
  private readonly navigationService = inject(NavigationService);

  model: any = {};
  public error$: Observable<string | undefined>;

  @ViewChild('userNameInput', {static: true}) userNameInput;

  ngOnInit(): void {
    this.error$ = this.store$.select(appState => appState.userState.error);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.userNameInput.nativeElement.focus();
    });
  }

  login() {
    this.store$.dispatch(new Login({username: this.model.username, password: this.model.password}));
    this.navigateIfAuthenticated();
  }

  resetError() {
    this.store$.dispatch(new ClearUserError());
  }

  navigateIfAuthenticated() {
    this.store$.select(appState => appState.userState.loaded).pipe(
      filter(loaded => loaded),
      take(1),
      withLatestFrom(this.store$.select(appState => appState.userState.authenticated)),
    ).subscribe(
      ([_loadState, authenticated]: [boolean, boolean]) => {
        if (authenticated) {
          this.navigationService.navigateToReturnUrl();
        }
      }
    );
  }
}
